module.exports = __webpack_public_path__ + "img/caret-left.df7cef58.svg";